<template>
  <div ref="echart01" style="width:250px; height:200px;"></div>
</template>

<script>
export default {
  props:{
    data06:{type: Object}
  },
  mounted() {
    let chart01 = this.$echarts.init(this.$refs.echart01)
    let ratio= this.data06
    // let ratio = 40 //占比数值  总数为100
    let ratioLength = 3 //波浪数量
    let ratioArr = []
    let ratioColor = ['#1991d2', '#3831f3', '#1991d2'] //波浪内颜色
    for (let ratioIndex = 0; ratioIndex < ratioLength; ratioIndex++) {
      ratioArr.push(ratio / 100)
    }
    let option = {
      // backgroundColor: '#003366',
      title: {
        text: ratio + '%',
        textStyle: {
          fontSize: 21,
          fontFamily: 'Microsoft Yahei',
          fontWeight: 'bold',
          color: '#fff'
        },
        x: 'center',
        y: 'center'
      },
      series: [
        {
          type: 'liquidFill',
          radius: '70%',
          center: ['50%', '50%'],
          color: ratioColor,
          data: ratioArr,
          backgroundStyle: {
            // borderWidth: 1,
            color: '#1f2c52'
          },
          label: {
            normal: {
              formatter: ''
            }
          },
          outline: {
            show: false
          }
        },
        {
          //细的外圈
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['79%', '80%'],
          hoverAnimation: false,
          data: [
            {
              name: '',
              value: 50,
              labelLine: {
                show: false
              },
              itemStyle: {
                color: 'transparent'
              },
              emphasis: {
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: 'transparent'
                }
              }
            },

            {
              //画剩余的刻度圆环
              name: '',
              value: 50,
              itemStyle: {
                color: '#41496b'
              },
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              emphasis: {
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: '#41496b'
                }
              }
            }
          ]
        },
        {
          //粗的外圈
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['78%', '81%'],
          hoverAnimation: false,
          zlevel: 2,
          data: [
            {
              name: '',
              value: 50,
              labelLine: {
                show: false
              },
              itemStyle: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#00e2fe'
                  },
                  {
                    offset: 1,
                    color: '#0707ff'
                  }
                ])
              },
              emphasis: {
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: '#00e2fe'
                    },
                    {
                      offset: 1,
                      color: '#0707ff'
                    }
                  ])
                }
              }
            },

            {
              //画剩余的刻度圆环
              name: '',
              value: 50,
              itemStyle: {
                color: 'transparent'
              },
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              emphasis: {
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: 'transparent'
                }
              }
            }
          ]
        }
      ]
    }
    chart01.setOption(option, true)
  }
}
</script>

<style></style>
